export default function SettingsPage() {
  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2 className="page-title">Configuración</h2>
          <p className="page-subtitle">Ajustes del sistema</p>
        </div>
      </div>

      <div className="card settings-card">
        <h3>Información del sistema</h3>
        <div className="settings-info-grid">
          <div className="settings-info-item">
            <span className="settings-info-label">Versión</span>
            <span className="settings-info-value">1.0.0</span>
          </div>
          <div className="settings-info-item">
            <span className="settings-info-label">API Base</span>
            <span className="settings-info-value">{window.location.origin || "http://localhost:32007"}</span>
          </div>
          <div className="settings-info-item">
            <span className="settings-info-label">Entorno</span>
            <span className="settings-info-value">Desarrollo</span>
          </div>
        </div>
      </div>

      <div className="card settings-card">
        <h3>Acciones</h3>
        <div className="settings-actions">
          <button
            className="btn btn-danger"
            onClick={() => {
              localStorage.clear();
              window.location.reload();
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
}